module.exports = "/fonts/vendor/material-icons/iconmaterial-icons-outlined.woff?0e4321a7c0dda51d72a669ac5892fc39";